import { computed, ref, watch } from 'vue';
import { useRoute } from 'vue-router';
import { useContext } from '@sa/hooks';
import { useRouteStore } from '@/store/modules/route';
import { useVersionStore } from '@/store/modules/version';
import { deduplicateMenus } from '@/utils/menu-deduplication';
export const { setupStore: setupMixMenuContext, useStore: useMixMenuContext } = useContext('mix-menu', useMixMenu);

function useMixMenu() {
  const route = useRoute();
  const routeStore = useRouteStore();
  const versionStore = useVersionStore();
  const { selectedKey } = useMenu();

  const activeFirstLevelMenuKey = ref('');

  function setActiveFirstLevelMenuKey(key: string) {
    activeFirstLevelMenuKey.value = key;
  }

  function getActiveFirstLevelMenuKey() {
    const [firstLevelRouteName] = selectedKey.value.split('_');

    setActiveFirstLevelMenuKey(firstLevelRouteName);
  }

  // 根据当前版本过滤菜单项
  function filterMenusByVersion(menus: App.Global.Menu[]): App.Global.Menu[] {
    const currentVersion = versionStore.version;

    // console.log('currentVersion', currentVersion);
    // console.log(
    //   'menus',
    //   menus.map((menu) => menu.key)
    // );

    const filteredMenus = menus.filter(menu => {
      // 基地版货物模块只在基地版显示
      // if (menu.key === 'base-goods' && currentVersion !== 'BASE') {
      //   return false;
      // }

      // 非基地版货物模块只在非基地版显示
      // if (menu.key === 'nonbase-goods' && currentVersion === 'BASE') {
      //   return false;
      // }
      // ✅【新增】库存管理（inventory）仅在 BASE 版本显示
      // if (menu.key === 'inventory' && currentVersion !== 'BASE') {
      //   return false;
      // }
      // 递归过滤子菜单
      if (menu.children?.length) {
        menu.children = filterMenusByVersion(menu.children);
      }

      return true;
    });

    // 使用去重工具函数处理菜单重复问题
    return deduplicateMenus(filteredMenus);
  }

  const allMenus = computed<App.Global.Menu[]>(() => {
    return filterMenusByVersion(routeStore.menus);
  });

  const firstLevelMenus = computed<App.Global.Menu[]>(() =>
    allMenus.value.map(menu => {
      const { children: _, ...rest } = menu;

      return rest;
    })
  );

  const childLevelMenus = computed<App.Global.Menu[]>(() => allMenus.value.find(menu => menu.key === activeFirstLevelMenuKey.value)?.children || []);

  const isActiveFirstLevelMenuHasChildren = computed(() => {
    if (!activeFirstLevelMenuKey.value) {
      return false;
    }

    const findItem = allMenus.value.find(item => item.key === activeFirstLevelMenuKey.value);

    return Boolean(findItem?.children?.length);
  });

  watch(
    () => route.name,
    () => {
      getActiveFirstLevelMenuKey();
    },
    { immediate: true }
  );

  // 监听版本变化
  watch(
    () => versionStore.version,
    () => {
      getActiveFirstLevelMenuKey();
    }
  );

  return {
    allMenus,
    firstLevelMenus,
    childLevelMenus,
    isActiveFirstLevelMenuHasChildren,
    activeFirstLevelMenuKey,
    setActiveFirstLevelMenuKey,
    getActiveFirstLevelMenuKey
  };
}

export function useMenu() {
  const route = useRoute();

  const selectedKey = computed(() => {
    const { hideInMenu, activeMenu } = route.meta;
    const name = route.name as string;

    const routeName = (hideInMenu ? activeMenu : name) || name;

    return routeName;
  });

  return {
    selectedKey
  };
}
